// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface ContentBoxIconSignature {
  Element: SVGSVGElement;
}

export const ContentBoxIcon: TOC<ContentBoxIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M4 3.00098H20C21.104 3.00098 22 3.89898 22 5.00098V8.00098C22 8.55298 21.553 9.00098 21 9.00098V19.001C21 20.104 20.104 21.001 19 21.001H5C3.896 21.001 3 20.104 3 19.001V9.00098C2.447 9.00098 2 8.55298 2 8.00098V5.00098C2 3.89898 2.896 3.00098 4 3.00098ZM20 7.00098V5.00098H4V7.00098H20ZM19 19.001H5V9.00098H19V19.001ZM15 10.001H9V13.001H15V10.001Z"/>
</svg>
</template>;